export default "__VITE_ASSET__QB6CunSW__"